import gql from 'graphql-tag';

const MUTATION_DEACTIVATE_USER = gql`
  mutation deactivateUser {
    deactivateUser
  }
`;

export const deactivateUser = client => () =>
  client.mutate({
    mutation: MUTATION_DEACTIVATE_USER
  });
